import React from 'react';
import {
  components as DefaultSelectComponents,
  ControlProps,
} from 'react-select';
import classNames from 'classnames';
import Chip, { ChipSizes, ChipTypes } from '@lib/components/Chip/Chip';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import { InputSizes } from '@lib/components/Input/enums';
import styles from '../Select.module.scss';

const rightIconComponent = (isOpen: boolean) => (
  <MaterialIcon icon={isOpen ? 'arrow_drop_up' : 'arrow_drop_down'} />
);

export default function ChipControl(props: ControlProps): React.ReactElement {
  const { children, ...restProps } = props;
  const { selectProps, isFocused, isMulti } = restProps;
  // @ts-ignore TODO: fix it (https://react-select.com/typescript#custom-select-props)
  const { menuIsOpen, isDisabled, size, chipControlProps } = selectProps;
  const controlClassName = classNames(styles.control, styles.chipControl, {
    isFocused,
    isDisabled,
    menuIsOpen,
  });
  let chipSize = ChipSizes.small;
  if (size === InputSizes.large) {
    chipSize = ChipSizes.large;
  }
  let counter: number | undefined;
  if (isMulti && chipControlProps?.counter) {
    counter = chipControlProps.counter;
  } else if (isMulti && chipControlProps?.useCounter && restProps?.getValue) {
    counter = restProps?.getValue()?.length;
  }
  const rightIconComponentValue = isDisabled
    ? undefined
    : rightIconComponent(menuIsOpen);
  return (
    // @ts-ignore
    <DefaultSelectComponents.Control
      {...restProps}
      className={controlClassName}
    >
      <Chip
        counter={counter}
        label={children}
        leftIcon={chipControlProps?.leftIcon}
        leftIconClassName={chipControlProps?.leftIconClassName}
        leftIconComponent={chipControlProps?.leftIconComponent}
        leftIconSymbolsOutlined={chipControlProps?.leftIconSymbolsOutlined}
        rightIconComponent={rightIconComponentValue}
        size={chipControlProps?.size || chipSize}
        tooltipForCroppedTextDisabled
        type={chipControlProps?.type || ChipTypes.chipGray}
      />
    </DefaultSelectComponents.Control>
  );
}
